export default __webpack_public_path__ + "static/media/decible_.b7ef6102.jpg";